import React, { Component, Fragment } from 'react';
import { NavLink, withRouter } from "react-router-dom";
import Locale from './Entities/Locale.js';
import { withApi, showIfAuthenticated } from './Providers/WebServiceProvider.js';
import { withValidLocales } from './Providers/LocalesProvider.js';
import ability from './abilities'
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

class Sidebar extends Component
{
  constructor (props) {
    super(props);

    this.state = {
      activeSection: null,
      loaded: false
    };

    this.toggleSection = this.toggleSection.bind(this);
    this.getSectionClass  = this.getSectionClass.bind(this);
  }

  componentWillReceiveProps(newProps) {
    const { location } = newProps;

    if (/translate/.test(location.pathname)) {
      this.toggleSection('translate', false);
    } else if (/validate/.test(location.pathname)) {
      this.toggleSection('validate', false);
    }

    this.setState({ loaded: true });
  }

  getSectionClass (param) {
    return (this.state.activeSection === param) ? 'item head is-active' : 'item head';
  } 

  toggleSection (param, collapseIfSelected) { 
    if (this.state.activeSection === param && collapseIfSelected) {
      param = null;
    }

    this.setState({ activeSection: param });
  }

  buildLocaleLinks (locales, uri) {
    const that = this;

    if (!this.props.localesContext.ready) {
      return 'Loading...';
    }
  
    if (!locales.length) {
      return null;
    }

    return locales.map(function (locale) {
      if (ability.can(uri, new Locale({ key: locale.props.key })) || ability.can('read', new Locale({ key: locale.props.key }))) 
      {
        return (
          <NavLink replace key={uri + '.' + locale.props.key} to={'/' + uri + '/' + locale.props.key} activeClassName="is-active"> 
            <li className="item no-left-padding" key={uri + '-' + locale.props.key}>
              <span className="content">{locale.props.name} ({locale.props.key})</span>
            </li>
          </NavLink>
        );
      } else {
        return null;
      }
    });  
  }

  buildTranslateSection (a) {
    if (a.can('translate', 'locales') || a.can('read', 'locales')) {
      const links = this.buildLocaleLinks(this.props.localesContext.locales, 'translate');

      return (
        <Fragment>
          <li className={this.getSectionClass('translate')} onClick={() => this.toggleSection('translate', true)}>
            <span className="label-icon">
              <FontAwesomeIcon icon="pencil-alt" color="#dcdcdc" fixedWidth /> 
            </span>
            Translate
          </li>
          <li className={this.state.activeSection === 'translate' ? 'collapsable' : "collapsable collapsed"}>
            <ul>
              {links}
            </ul>
          </li>
        </Fragment>
      );
    }
  }

  buildValidateSection (a) {
    if (a.can('validate', 'locales')) {
      const links = this.buildLocaleLinks(this.props.localesContext.locales, 'validate');

      return (
        <Fragment>
          <li className={this.getSectionClass('validate')} onClick={() => this.toggleSection('validate', true)}>
            <span className="label-icon">
              <FontAwesomeIcon icon="clipboard-check" color="#dcdcdc" fixedWidth /> 
            </span>
            Validate
          </li>
          <li className={this.state.activeSection === 'validate' ? 'collapsable' : "collapsable collapsed"}>
            <ul>
              {links}
            </ul>
          </li>
        </Fragment>
      );
    }
  }

	render () {
    if (this.state.loaded) {
      return (
        <aside className="menu sidebar">
          <ul className="menu-list">
            {this.buildTranslateSection(ability)}
            {this.buildValidateSection(ability)}
          </ul>
        </aside>
      );
    } else {
      return (
        <div style={{textAlign: 'center', marginTop: '0.5rem', fontSize: '4rem'}}>
          <FontAwesomeIcon spin icon="circle-notch" />
        </div>
      );
    }
	}
}

export default withValidLocales(showIfAuthenticated(withRouter(Sidebar)));


// WEBPACK FOOTER //
// ./src/Sidebar.js